import { LocalizedText } from '@mews/framework/localization';
import { TextKey } from '@mews-distributor/common';
import { Banner } from '@optimus-web/core';

export const CheckoutError = ({ hasError }: { hasError: boolean }) =>
    hasError ? (
        <Banner centered variant="error" primaryText={<LocalizedText textKey={TextKey.ValidationErrorMessage} />} />
    ) : null;
